/* ============================================================
   CHRONCES — <cr-review-text>
   Dépliage d'un avis trop long.

   🚨 AUCUN pop-up. C'est tout l'objet de cette section : le widget
   Judge.me ouvrait une fenêtre par-dessus la page au clic sur
   « lire la suite », et une seconde se déclenchait derrière. Ici le
   texte se déplie sur place, dans sa carte.

   Le bouton est créé en JavaScript, jamais rendu par Liquid : sans
   JS il n'existe pas, et le texte reste simplement tronqué par le
   CSS — entier dans le DOM, donc lisible et indexable.
   ============================================================ */

class CrReviewText extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('[data-cr-text]');
    if (!this.text) return;

    // Rien à déplier si tout tient déjà : un bouton qui n'ouvre rien est
    // pire que pas de bouton.
    // ⚠️ PAS de `requestAnimationFrame` : il ne part jamais dans un onglet
    // qui ne compose pas de frame — le bouton n'existait alors nulle part et
    // c'est invisible à la relecture du code. `setTimeout` suffit : lire
    // `scrollHeight` force de toute façon un calcul de mise en page.
    setTimeout(() => this.setup(), 0);

    // Titan One, Poppins et Genty n'ont pas les métriques des polices de
    // repli : tant qu'elles ne sont pas chargées, la hauteur mesurée est
    // celle d'un autre texte. On repasse une fois qu'elles sont là.
    document.fonts?.ready.then(() => this.setup());
  }

  setup() {
    if (this.button) return;
    if (this.text.scrollHeight <= this.text.clientHeight + 2) return;

    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'cr-rw__more';
    this.button.textContent = this.dataset.more || 'Lire la suite';
    this.button.setAttribute('aria-expanded', 'false');
    this.button.addEventListener('click', this.toggle);
    this.append(this.button);
  }

  toggle = () => {
    this.expanded = !this.expanded;
    this.classList.toggle('is-open', this.expanded);
    this.button.textContent = this.expanded
      ? this.dataset.less || 'Réduire'
      : this.dataset.more || 'Lire la suite';
    this.button.setAttribute('aria-expanded', String(this.expanded));
  };

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
  }
}

if (!customElements.get('cr-review-text')) {
  customElements.define('cr-review-text', CrReviewText);
}
